import { defineStore } from 'pinia';
import { store } from '@/store';
import { ACCESS_TOKEN, CURRENT_USER, IS_SCREENLOCKED } from '@/store/mutation-types';
import { ResultEnum } from '@/enums/httpEnum';

import { getUserInfo as getUserInfoApi, login } from '@/api/system/user';
import { storage } from '@/utils/Storage';
import { md5 } from '@/utils/crypt';

export type UserInfoType = {
  // TODO: add your own data
  name: string;
  email: string;
};

export interface IUserState {
  token: string;
  username: string;
  welcome: string;
  avatar: string;
  permissions: any[];
  info: UserInfoType;
}

export const useUserStore = defineStore({
  id: 'app-user',
  state: (): IUserState => ({
    token: storage.get(ACCESS_TOKEN, ''),
    username: '',
    welcome: '',
    avatar: '',
    permissions: [],
    info: storage.get(CURRENT_USER, {}),
  }),
  getters: {
    getToken(): string {
      return this.token;
    },
    getAvatar(): string {
      return this.avatar;
    },
    getNickname(): string {
      return this.username;
    },
    getPermissions(): [any][] {
      return this.permissions;
    },
    getUserInfo(): UserInfoType {
      return this.info;
    },
    isAdmin(): boolean {
      return this.info?.name === 'admin';
    }
  },
  actions: {
    setToken(token: string) {
      this.token = token;
    },
    setAvatar(avatar: string) {
      this.avatar = avatar;
    },
    setPermissions(permissions) {
      this.permissions = permissions;
    },
    setUserInfo(info: UserInfoType) {
      this.info = info;
    },
    // 登录
    async login(params: any) {
      const passwordMd5 = md5(params.password)
      // const response = await login(params);
      let response = {code:ResultEnum.ERROR, data:{token:'12', name:params.username, email:'ok'}} // debug
      if (params.username === 'tensorbay' && passwordMd5 === '108d231d71d294b46907997775297dcc') {
        response = {code:ResultEnum.SUCCESS, data:{token:'123', name:'admin',email:'ok'}} // debug
      } else if (params.username === 'tuzong' && passwordMd5 === 'ca07d66162da0e2a286ef86ab35df473') {
        response = {code:ResultEnum.SUCCESS, data:{token:'123', name:'admin',email:'ok'}} // debug
      } else if (params.username === 'game' && passwordMd5 === 'b1d4b6452378d64ccbfe7f20fca7843c') {
        response = {code:ResultEnum.SUCCESS, data:{token:'123', name:'game',email:'ok'}} // debug
      }
      const { data, code } = response;
      if (code === ResultEnum.SUCCESS) {
        const ex = 7 * 24 * 60 * 60;
        storage.set(ACCESS_TOKEN, data.token, ex);
        storage.set(CURRENT_USER, data, ex);
        storage.set(IS_SCREENLOCKED, false);
        this.setToken(data.token);
        this.setUserInfo(data);
      }
      return response;
    },

    // 获取用户信息
    async getInfo() {
      // const result = await getUserInfoApi();
      const adminInfo = {
        name: 'admin',
        email: 'admin@admin.com',
        userId: '1',
        username: 'tensorbay',
        realName: 'Admin',
        avatar: '',
        desc: 'manager',
        password: '123456',
        token:'123',
        permissions: [
          {
            label: '主控台',
            value: 'dashboard_console',
          },
          {
            label: '监控页',
            value: 'dashboard_monitor',
          },
          {
            label: '操作栏',
            value: 'basic_list',
          },
          {
            label: '素材管理',
            value: 'material',
          },
          {
            label: '素材分类',
            value: 'material_type',
          },
          {
            label: '素材背景',
            value: 'material_bg',
          },
          {
            label: '素材道具',
            value: 'material_prop',
          },
          {
            label: '素材角色',
            value: 'material_role',
          },
          {
            label: '作品管理',
            value: 'project',
          },
          {
            label: '作品列表',
            value: 'project_list',
          },
        ],
      };
      const gameUserInfo = {
        name: 'game',
        email: 'game@game.com',
        userId: '1',
        username: 'game',
        realName: 'game',
        avatar: '',
        desc: 'manager',
        password: '17000',
        token:'123',
        permissions: [
          {
            label: '素材管理',
            value: 'material',
          },
          {
            label: '素材分类',
            value: 'material_type',
          },
          {
            label: '素材背景',
            value: 'material_bg',
          },
          {
            label: '素材道具',
            value: 'material_prop',
          },
          {
            label: '素材角色',
            value: 'material_role',
          },
          {
            label: '作品管理',
            value: 'project',
          },
          {
            label: '作品列表',
            value: 'project_list',
          },
        ],
      };
      const { name } = storage.get(CURRENT_USER, { name: 'admin' })
      let result = adminInfo;
      if ( name == gameUserInfo.name) {
        result = gameUserInfo;
      }
      if (result.permissions && result.permissions.length) {
        const permissionsList = result.permissions;
        this.setPermissions(permissionsList);
        this.setUserInfo(result);
      } else {
        throw new Error('getInfo: permissionsList must be a non-null array !');
      }
      this.setAvatar(result.avatar);
      return result;
    },

    // 登出
    async logout() {
      this.setPermissions([]);
      this.setUserInfo({ name: '', email: '' });
      storage.remove(ACCESS_TOKEN);
      storage.remove(CURRENT_USER);
    },
  },
});

// Need to be used outside the setup
export function useUser() {
  return useUserStore(store);
}
